import React, { FC, useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';

import MainProgress from '../MainProgress';
import { MainProgressContext } from '../context/MainProgressContext';

const MainProgressProvider: FC = (props) => {
  const [prevPathname, setPrevPathname] = useState('');
  const location = useLocation();
  const [visibility, setVisibility] = useState(false);
  const show = useCallback(() => {
    setVisibility(true);
  }, [setVisibility]);
  const hide = useCallback(() => {
    setVisibility(false);
  }, [setVisibility]);
  const value = useMemo(() => ({ visibility, show, hide }), [visibility, show, hide]);

  useLayoutEffect(() => {
    if (prevPathname !== location.pathname) {
      setPrevPathname(location.pathname);
      show();
    }
  }, [location]);

  return (
    <MainProgressContext.Provider value={value}>
      <MainProgress />
      {props.children}
    </MainProgressContext.Provider>
  );
};

export default MainProgressProvider;
